<template>
  <div v-loading="isLoading">
    <el-breadcrumb
      separator-class="el-icon-arrow-right"
      class="container mb10 mt10"
    >
      <el-breadcrumb-item :to="{ path: '/course' }"
        >课程中心</el-breadcrumb-item
      >
      <el-breadcrumb-item>课程考试</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="start container" v-if="detail">
      <div class="ohide">
        <div class="BGwhite pad30 gray1 flex radius8 mb20">
          <div class="top-left">
            <img src="@/assets/img/home/42.png" alt="" />
          </div>
          <div class="top-center flex1">
            <p class="name mb3">{{ detail.PaperName }}</p>
            <p class="content">
              <span>题量：{{ detail.TotalNum }}</span>
              <span>时长：{{ detail.Duration }}分钟</span>
              <span>总分：{{ detail.TotalScore }}</span>
            </p>
          </div>
          <div class="top-right">
            <div class="daojishi">
              <p class="C999">
                <span class="Corange size24 b600"
                  >{{ formatTime(Hand_CD)[0] }}:</span
                >
                <span class="Corange size24 b600"
                  >{{ formatTime(Hand_CD)[1] }}:</span
                >
                <span class="Corange size24 b600">{{
                  formatTime(Hand_CD)[2]
                }}</span>
              </p>
              <el-button
                type="primary"
                class="hand"
                @click="hand()"
                v-loading="isLoading"
                >交卷</el-button
              >
            </div>
          </div>
        </div>
      </div>
      <div class="card-box">
        <div class="card BGwhite mb20 flex1 ohide radius8 max50Img">
          <div class="card-top">
            <div>
              {{ cardIndex + 1 }}
              <span class="ml20">#{{ cardInfo.QTypeName }}</span
              >（{{ cardInfo.Score }}分）
            </div>
            <el-button v-if="!cardInfo.IsMark" class="testBtn" @click="mark('1')">
              <img src="@/assets/img/home/44.png" alt="" />标记题目</el-button
            >
            <el-button v-else class="testBtn2" @click="mark('0')">
              <img src="@/assets/img/home/43.png" alt="" />取消标记</el-button
            >
          </div>
          <div v-html="cardInfo.QTitle" class="card-content"></div>
          <div class="card-answer mt20">
            <div
              v-for="(options, index) in cardInfo.Options"
              :key="index"
              class="card-answer-item"
            >
              <el-radio
                @change="save(options)"
                class="block mb20 size16"
                :label="options.OptionNo"
                v-model="cardInfo.SubAnswer"
                v-if="cardInfo.QType == 1"
              >
                <span class="OptionNo">{{ options.OptionNo }}</span>
                <span v-html="options.OptionValue" class="OptionValue"></span>
              </el-radio>
              <el-radio
                @change="save(options)"
                class="block mb20 size16"
                :label="options.OptionNo"
                v-model="cardInfo.SubAnswer"
                v-if="cardInfo.QType == 3"
              >
                <span v-html="options.OptionValue" class="OptionValue"></span>
              </el-radio>
              <el-checkbox
                @change="save(options, cardInfo)"
                v-if="cardInfo.QType == 2"
                v-model="options.IsChecked"
                class="block mb20 size16"
                :label="options.OptionNo"
              >
                {{ options.OptionNo }}.
                <span v-html="options.OptionValue"></span>
              </el-checkbox>
            </div>
          </div>
          <div v-if="cardInfo.QType == 4" class="mr20">
            <el-input
              class="mb15"
              @change="save(cardInfo)"
              v-model="cardInfo.SubAnswer"
              placeholder="请输入答案"
              type="textarea"
              rows="5"
            ></el-input>
          </div>
        </div>
        <div class="width355px ml20 b500 part35">
          <div class="BGwhite radius8 pad20 mb1 size18 dtTitle">答题卡</div>
          <div class="pad20 BGwhite radius8 C999 mb20">
            <div class="scroll" style="max-height: calc(100vh - 550px)">
              <div class="flex">
                <div
                  v-for="(card, index) in detail.CardItems"
                  :key="index"
                  @click="selectCd(card, index)"
                  :class="{
                    BGons: card.SubAnswer,
                    Mark: card.IsMark == true,
                    active: index == cardIndex && !card.IsMark,
                  }"
                  class="radius8 line38 pointer item"
                >
                  <span v-if="!card.IsMark">{{ index + 1 }}</span>
                </div>
              </div>
            </div>
            <div v-if="detail.TotalNum > 1">
              <div v-if="cardIndex == 0" class="btns mt20">
                <el-button
                  type="primary"
                  class="btn"
                  style="width: 100%"
                  @click="next()"
                  >下一题</el-button
                >
              </div>
              <div v-if="cardIndex == detail.TotalNum - 1" class="btns mt20">
                <el-button
                  type="primary"
                  class="btn"
                  style="width: 100%"
                  @click="prev()"
                  >上一题</el-button
                >
              </div>
              <div
                v-if="cardIndex > 0 && cardIndex < detail.TotalNum - 1"
                class="btns mt20"
              >
                <el-button
                  type="primary"
                  v-if="cardIndex != 0"
                  class="btn"
                  @click="prev()"
                  >上一题</el-button
                >
                <el-button
                  v-if="cardIndex != detail.TotalNum - 1"
                  type="primary"
                  class="btn"
                  @click="next()"
                  >下一题</el-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="试题纠错"
      :visible.sync="dialogSshow"
      width="460px"
      :append-to-body="true"
      class="part27"
    >
      <el-select v-model="form.dType" placeholder="请选择">
        <el-option
          v-for="item in eTypeList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-input
        class="size14"
        type="textarea"
        placeholder="请输入反馈信息..."
        v-model="form.body"
        rows="6"
        maxlength="100"
        show-word-limit
      >
      </el-input>
      <span slot="footer" class="dialog-footer" v-loading="correctionLoading">
        <el-button @click="dialogSshow = false">取 消</el-button>
        <el-button type="primary" @click="correction()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  Exam_GetExamInfo,
  Exam_Mark,
  Exam_SaveAnswer,
  Exam_Hand,
} from "@/api/exam";
export default {
  name: "cardDetail",
  data() {
    return {
      dialogSshow: false,
      detail: null,
      cardInfo: null,
      cardIndex: 0,
      form: {
        QuesID: 0,
        dType: 1,
        body: "",
      },
      Hand_CD: null,
      eTypeList: [
        { label: "题干错误", value: 1 },
        { label: "答案错误", value: 2 },
      ],
      percentage: 0,
      correctionLoading: false, // 矫正
      ExamID: this.$route.query.ExamID,
      UEID: this.$route.query.UEID,
    };
  },
  watch: {
    // detail: {
    //   deep: true,
    //   handler(v) {
    //     let total = 0;
    //     let finsh = 0;
    //     v.CardItems.map((card) => {
    //       if (card.QType == 4 && card.SubAnswer.join("").length > 0) {
    //         finsh++;
    //       } else if (card.QType < 4 && card.SubAnswer.length > 0) {
    //         finsh++;
    //       }
    //       total++;
    //       // card.Options.map(({ SubAnswer, QType }) => {
    //       //   total++;
    //       // });
    //     });
    //     this.percentage = Math.floor((finsh / total) * 100);
    //   },
    // },
    cardIndex(a, b) {
    },
  },
  components: {},
  created() {
    this.getCard(true);
    // document.addEventListener("visibilitychange", () => {
    //   var isHidden = document.hidden;
    //   if (isHidden) {
    //     // 切离该页面时执行，逻辑处理
    //     console.log("浏览器处于最小化状态了或者切换到其他页面了");
    //   } else {
    //     // 切换到该页面时执行，逻辑处理
    //     console.log("页面处于当前状态了");
    //     this.getCard(false);
    //   }
    // });
  },
  // QType 1单选 2多选 3判断 4主观题
  methods: {
    prev() {
      if (this.cardIndex < 1) {
        this.cardIndex = 0;
        return;
      }
      this.cardIndex--;
      this.cardInfo = this.detail.CardItems[this.cardIndex];
    },
    next() {
      const that = this;
      if (this.cardIndex >= this.detail.TotalNum - 1) {
        this.cardIndex = this.detail.TotalNum - 1;
        for (let i = 0; i < this.detail.CardItems.length; i++) {
          if (!this.detail.CardItems[i].SubAnswer) {
            that.$message.warning(`第${i + 1}题未答`);
            break;
          }
        }
        return;
      }
      this.saveAnswer(this.detail.CardItems[this.cardIndex]);
      this.cardIndex++;
      this.cardInfo = this.detail.CardItems[this.cardIndex];
    },
    mark(StatusID) {
      Exam_Mark({
        ExamID: this.ExamID,
        QuesID: this.cardInfo.QuesID,
        StatusID: StatusID,
      }).then((res) => {
        console.log('this.cardInfo.IsMark',this.cardInfo.IsMark);
        this.detail.CardItems[this.cardIndex].IsMark = StatusID == '1'
        this.cardInfo.IsMark =StatusID ==  '1'
      });
    },
    selectCd(item, index) {
      this.cardInfo = item;
      this.cardIndex = index;
    },
    save(data, cardInfo) {
      if (data.QType === 2) {
        let arr = [];
        cardInfo.Options.map((item) => {
          if (item.IsChecked) {
            arr.push(item.OptionNo);
          }
        });
        cardInfo.SubAnswer = arr.join("");
      }
    },
    saveAnswer(data) {
      if (data.SubAnswer) {
        Exam_SaveAnswer({
          ExamID: this.ExamID,
          QuesID: data.QuesID,
          SubAnswer: data.SubAnswer,
        }).then((res) => {
          this.getCard();
        });
      }
    },

    hand(showMsg = true) {
      const fun = () => {
        let Options = [];
        this.detail.CardItems.map((card) => {
          let { SubAnswer, QType, QuesID } = card;
          // if (QType === 2) {
          //   SubAnswer = SubAnswer.join("");
          // }
          Options.push({ SubAnswer, QuesID });
        });

        this.isLoading = true;
        const data = {
          ExamID: this.ExamID,
          HandType: showMsg == true ? 1 : 2,
          QuesItems: Options,
        };
        Exam_Hand(data).then(() => {
          this.isLoading = false;
          this.$router.replace({
            path: "/exam/result",
            query: this.$route.query,
          });
        });
      };
      if (showMsg) {
        this.$confirm("确认交卷？").then(() => {
          Exam_SaveAnswer({
            ExamID: this.ExamID,
            QuesID: this.cardInfo.QuesID,
            SubAnswer: this.cardInfo.SubAnswer,
          }).then((res) => {
            fun();
          });
        });
      } else {
        fun();
      }
    },
    setTimer() {
      // 倒计时
      if (this.$store.state.timer) {
        clearInterval(this.$store.state.timer);
        clearTimeout(this.$store.state.timer);
        this.$store.state.timer = null;
      }
      if (this.Hand_CD <= 0) {
        this.$message.warning("考试时间已结束！");
        return this.hand(false);
      }
      if (this.Hand_CD && this.Hand_CD > 0) {
        this.$store.state.timer = setInterval(() => {
          if (this.Hand_CD > 0) {
            this.Hand_CD--;
          } else {
            this.setTimer();
          }
        }, 1000);
      }
    },
    getCard(reload = true) {
      if (reload) {
        this.isLoading = true;
      }
      Exam_GetExamInfo({
        ExamID: this.$route.query.ExamID,
      })
        .then(({ data }) => {
          this.Hand_CD = data.CDTime;
          this.cardInfo = data.CardItems[this.cardIndex];
          data.CardItems.map((item) => {
            if (item.QType === 1 || item.QType === 3 || item.QType === 4) {
              item.SubAnswer = item.SubAnswer || "";
            } else if (item.QType === 2) {
              item.SubAnswer = item.SubAnswer || "";
            }
            item.Options.map((ques) => {
              ques.QType = item.QType;
              if (ques.QType === 1 || ques.QType === 3 || ques.QType === 4) {
                ques.SubAnswer = item.SubAnswer || "";
              } else if (ques.QType == 2) {
                ques.SubAnswer =
                  (item.SubAnswer && item.SubAnswer.split("")) || [];
              }
            });
          });
          this.detail = data;
          this.setTimer();
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
//修改选中radio背景色、边框
//点击前的样式
::v-deep .el-radio__inner {
  border-radius: 50%;
  width: 26px;
  height: 26px;
}
::v-deep .el-radio__label {
  font-size: 16px;
}
//点击后的样式
::v-deep .el-radio__inner::after {
  width: 26px;
  height: 26px;
  //让圆框变成方框
  border-radius: 50%;
  //点击后方框中的图片
  background: url("~@/assets/img/home/61.png") no-repeat;
  background-size: 100% 100%;
  border: none;
  //图片适应方式
  ///background-size：contain，
  //background-size:150px 80px;
  //background-size:cover;
  //background-size:40% 60%;
}
/* 背景透明 */

/* 选中样式 */
::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
::v-deep .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  width: 26px;
  height: 26px;
  background: url("~@/assets/img/home/62.png") no-repeat;
  background-size: 100% 100%;
  border: none;
}
/* 大小 */
::v-deep .el-checkbox__inner {
  width: 26px;
  height: 26px;
}
/* 对勾样式 */
::v-deep .el-checkbox__inner::after {
  display: none;
}
::v-deep .el-checkbox__input.is-checked .el-checkbox__inner::after {
  transform: rotate(50deg) scaleY(1.3);
}
.dtTitle {
  position: relative;
  &::after {
    content: "";
    position: absolute;
    top: 24px;
    left: 0;
    width: 6px;
    height: 20px;
    background: #1d79ff;
    border-radius: 3px;
  }
}
.red {
  background: #ffe6e8;
  border-radius: 4px;
  text-align: center;
  color: #eb525c;
  width: 57px;
  line-height: 24px;
  cursor: pointer;
  transition: all 0.2s;
  &:hover {
    background: #eb525c;
    color: white;
  }
}
.container {
  .top-left {
    width: 70px;
    height: 70px;
    margin-right: 30px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .top-center {
    .name {
      font-weight: bold;
      font-size: 24px;
      color: #333333;
    }
    .content {
      font-size: 18px;
      color: #666666;
      span {
        margin-right: 50px;
      }
    }
  }
  .top-right {
    .daojishi {
      display: flex;
      align-items: center;
      gap: 20px;
    }
    .hand {
      width: 144px;
      height: 52px;
      background: #1d79ff;
      border-radius: 6px;
      font-size: 18px;
    }
  }
  .card-box {
    display: flex;
    min-height: 600px;
    .card {
      padding: 20px;
      .card-top {
        display: flex;
        gap: 20px;
        align-items: center;
        font-size: 18px;
        color: #666666;
        .testBtn {
          width: 124px;
          height: 36px;
          line-height: 1px;
          font-size: 16px;
          color: #ef4a4a;
          background: #ffffff;
          border-radius: 18px;
          border: 1px solid #ef4a4a;
          img {
            width: 20px;
            height: 19px;
            margin-top: -5px;
            margin-right: 5px;
            margin-left: -5px;
          }
        }
        .testBtn2 {
          font-size: 16px;
          color: #ffffff;
          width: 124px;
          height: 36px;
          line-height: 1px;
          background: #ef4a4a;
          border-radius: 18px;
          border: 1px solid #ef4a4a;
          img {
            width: 20px;
            height: 19px;
            margin-top: -5px;
            margin-right: 5px;
            margin-left: -5px;
          }
        }
      }
      .card-content {
        font-size: 20px;
        color: #333333;
        line-height: 36px;
        margin-top: 10px;
      }
      .card-answer {
        font-size: 18px;
        color: #333333;
        line-height: 34px;

        .OptionNo {
          font-size: 20px;
          color: #333333;
          font-weight: bold;
          margin-left: 13px;
          margin-right: 20px;
        }
        .OptionValue {
          font-size: 18px;
          color: #333333;
        }
      }
    }
  }
  .scroll {
    padding-bottom: 60px;
    .flex {
      gap: 10px;
      .item {
        width: 53px;
        height: 53px;
        line-height: 53px;
        text-align: center;
        background: #f6f8fc;
        border-radius: 10px;
        border: 1px solid #e9ecf0;
        font-weight: bold;
        font-size: 18px;
        color: #999999;
      }
      .BGons {
        width: 53px;
        height: 53px;
        line-height: 53px;
        text-align: center;
        background: #f6f8fc;
        border-radius: 10px;
        border: 1px solid #1d79ff;
        font-weight: bold;
        font-size: 18px;
        color: #1d79ff;
      }
      .Mark {
        background: url("~@/assets/img/home/45.png") no-repeat;
        background-size: 100% 100%;
        border: none;
      }
      .active {
        background: #1d79ff;
        border-radius: 10px;
        border: 1px solid #1d79ff;
        font-weight: bold;
        font-size: 18px;
        color: #ffffff;
      }
    }
  }
  .btns {
    display: flex;
    gap: 20px;
    .btn {
      width: 145px;
      height: 52px;
      background: #1d79ff;
      border-radius: 6px;
      font-size: 18px;
      color: #ffffff;
    }
  }
}
</style>
